var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddmore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658",
    transform: "translate(-1166 -305)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_310",
    "data-name": "Ellipse 310",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(1166 305)",
    fill: "#52c8f8",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1650",
    "data-name": "Group 1650",
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1533",
    "data-name": "Rectangle 1533",
    transform: "translate(1178 313)",
    fill: "#fff",
    stroke: "#52c8f8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.4,
    height: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.4,
    height: 18,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1534",
    "data-name": "Rectangle 1534",
    transform: "translate(1169 323) rotate(-90)",
    fill: "#fff",
    stroke: "#52c8f8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.4,
    height: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.4,
    height: 18,
    fill: "none"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddmore);
export default __webpack_public_path__ + "static/media/Addmore.c8a0d8fb1ddbbbec43c65ad9a2f254df.svg";
export { ForwardRef as ReactComponent };